import { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

export default function OfflineNotifier() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showOnlineMessage, setShowOnlineMessage] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      setShowOnlineMessage(false);
    };

    const handleOnline = () => {
      setIsOffline(false);
      setShowOnlineMessage(true);

      // Hide the online message after 3 seconds
      setTimeout(() => {
        setShowOnlineMessage(false);
      }, 3000);
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return (
    <>
      <Snackbar open={isOffline} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="error" sx={{ width: '100%' }}>
          You are currently offline!
        </Alert>
      </Snackbar>

      <Snackbar
        open={showOnlineMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          You're back online!
        </Alert>
      </Snackbar>
    </>
  );
}
